import React from 'react';
import { Navigation } from '../components/Navigation';
import { SmsHero } from '../components/SmsHero';
import { SmsWhyUs } from '../components/SmsWhyUs';
import { SmsServices } from '../components/SmsServices';
import { SmsFAQ } from '../components/SmsFAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function SmsPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-834">
      <Navigation data-id="element-835" />

      <main className="pt-[72px]" data-id="element-836">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SmsHero data-id="element-837" />
        <Consultation data-id="element-838" />
        <SmsWhyUs data-id="element-839" />
        <SmsServices data-id="element-840" />
        <SmsFAQ data-id="element-841" />
        <Testimonials data-id="element-842" />
        <Consultation data-id="element-843" />
      </main>

      <Footer data-id="element-844" />
      <CookieBanner data-id="element-845" />
      <FloatingContact data-id="element-846" />
    </div>;
}